import ItemCard from "./ItemCard";
import { useCallback, useState } from "react";
import ViewAll from "../UI-item,viewAll,BtmSheet/ViewAll";
import { useQuery } from "react-query";
const url = process.env.React_App_Api_url;

const getProducts = async (param) => {
  try {
    const response = await fetch(`${url}/${param}`);
    let resResult = await response.json();
    if (!resResult.length) {
      const backup = await fetch(`${url}/backup`);
      resResult = await backup.json();
    }
    return resResult;
  } catch (error) {
    console.log("REQUEST FAILED AT GET PRODUCT", error);
  }
};

const ItemCatalogue = (props) => {
  const { title, subtitle, param, theme, titleImage } = props;
  const [addMoreIndex, setAddMoreIndex] = useState(5);

  const {
    data: products,
    isLoading: productLoading,
    isError: productError,
  } = useQuery([`CATALOGUE_${param}`], () => getProducts(param));

  const addMoreItem = useCallback(() => {
    if (products.length === 0) {
      return;
    }
    setAddMoreIndex(products.length);
  }, [products]);

  // console.log(products, addMoreIndex);
  return productLoading || productError ? null : (
    <div
      className="card-wrap"
      style={{
        background: theme
          ? "#F8DDDD"
          : "linear-gradient(180deg, #E6F0FF 0%, #FFFFFF 100%)",
      }}
    >
      <div className="d-flex align-items-center justify-content-between sec-title">
        {titleImage && (
          <img src={titleImage} alt="titleImg" className="titleImg m-0 me-2" />
        )}
        <div className="me-auto">
          <h2>{title}</h2>
          {subtitle && <h4>{subtitle}</h4>}
        </div>
        {/* <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            //TO PLP PAGE
          }}
        >
          View all <i className="bi bi-chevron-right"></i>
        </a> */}
      </div>
      <div className="horiz-scroll">
        <ItemCard items={products.slice(0, addMoreIndex)} />
        {addMoreIndex >= products?.length ? null : (
          <ViewAll
            items={products?.slice(products.length - 3, products.length)}
            navigateTo={addMoreItem}
          />
        )}
      </div>
    </div>
  );
};
export default ItemCatalogue;
